import * as types from '@/store/types'
import { throwError } from '@/utils/store'

export default {
  [types.FETCH_ACTION_LOG]: ({ commit, getters }, { name, page, limit }) => {
    commit(types.LOADING, name)
    return getters.apiService
      .fetchActionLog({ page, limit })
      .then(({ list, totalPage }) => {
        commit(types.SET_LIST, { name, list })
        commit(types.UPDATE_PARAMS, { name, params: { totalPage } })
      })
      .catch(throwError(commit, 'Ошибка получения журнала действий'))
      .finally(() => commit(types.LOADED, name))
  },
  [types.FETCH_ACTION_LOG_ITEM]: ({ state, commit, getters }, { name }) => {
    const { id } = state[name].model
    const { limit, currentPage: page, sort } = state[name].params
    const ordering = sort.order === 'descending' ? `-${sort.prop}` : sort.prop

    commit(types.LOADING, name)
    return getters.apiService
      .fetchActionLogItem(id, { page, limit, ordering })
      .then(({ list, type, totalPage }) => {
        commit(types.SET_LIST, { name, list })
        commit(types.UPDATE_MODEL, { name, model: { type } })
        commit(types.UPDATE_PARAMS, { name, params: { totalPage } })
      })
      .catch(throwError(commit, 'Ошибка получения списка критериев действия журнала действий'))
      .finally(() => commit(types.LOADED, name))
  }
}
